export default "__VITE_ASSET__50ab181d__"